import Link from 'next/link';
import cn from 'classnames';
// Types
import { GetStream_stream_store } from 'api/streams/types/GetStream';
import { GetStoreBySlug_store } from 'api/store/types/GetStoreBySlug';
import { GetStores_stores_entities } from 'api/store/types/GetStores';
import {
  GetMediaPost_getMediaPost_ImagePost_store,
  GetMediaPost_getMediaPost_VideoPost_store,
} from 'api/mediaPost/types/GetMediaPost';
import { GetStoreMerchProduct_getStoreMerchProduct_store } from 'api/merch/types/GetStoreMerchProduct';
import { GetMemorabiliaBySlug_getMemorabiliaBySlug_store } from 'api/memorabilia/types/GetMemorabiliaBySlug';
import { GetExperienceBySlug_getExperienceBySlug_store } from 'api/experiences/types/GetExperienceBySlug';
// Components
import FollowButton from 'components/FollowButton/FollowButton';
// UI
import Image from 'ui3/Image/Image';
import Text from 'ui3/Text/Text';
// Styles
import styles from './TalentBlock.module.scss';

export type TalentBlockStore =
  | GetStream_stream_store
  | GetStoreBySlug_store
  | GetStores_stores_entities
  | GetMediaPost_getMediaPost_VideoPost_store
  | GetMediaPost_getMediaPost_ImagePost_store
  | GetStoreMerchProduct_getStoreMerchProduct_store
  | GetMemorabiliaBySlug_getMemorabiliaBySlug_store
  | GetExperienceBySlug_getExperienceBySlug_store;

export type TalentBlockProps = {
  store: TalentBlockStore;
  talentName: string;
  avatarURL: string;
  profilePath: string;
  showFollowButton?: boolean;
  className?: string;
  /** Above-the-fold only — maps to eager + fetchPriority=high. */
  priority?: boolean;
};

const TalentBlock = ({
  store,
  talentName,
  avatarURL,
  profilePath,
  showFollowButton = true,
  className,
  priority = false,
}: TalentBlockProps) => {
  return (
    <div className={cn(styles.root, className)}>
      <Link href={profilePath} prefetch={false}>
        <a className={styles.talentLink}>
          <div className={styles.talentAvatar}>
            <Image
              src={avatarURL}
              alt={`${talentName || 'User'} avatar`}
              className={styles.avatarImage}
              // ssrFill: real CDN src in SSR HTML (not next/image 1×1 GIF).
              ssrFill
              priority={priority}
            />
          </div>
          <Text variant="body1Medium16" className={styles.talentName}>
            {talentName}
          </Text>
        </a>
      </Link>
      {showFollowButton && (
        <FollowButton
          store={store}
          startIcon="plus"
          unfollowStartIcon="minus"
          unfollowText="Following"
          className={styles.followButton}
          xs="small"
          followVariant="secondary"
          unfollowVariant="secondary"
          unfollowSubVariant="text"
        />
      )}
    </div>
  );
};

export default TalentBlock;
